/**
 * 微信需要使用的JS接口列表-需要鉴权
 */
export var common_authority = [];
/**
 * 微信需要使用的JS接口列表-不需要鉴权
 */

export var common_anonymous = [];
/**
 * 微信需要使用的JS接口列表-invoke方式调用-需要鉴权
 */

export var invoke_authority = ['selectExternalContact', 'openExistedChatWithMsg'];
/**
 * 微信需要使用的JS接口列表-invoke方式调用-不需要鉴权
 */

export var invoke_anonymous = [];
/**
 * 微信需要使用的JS接口列表-wx.*** 默认方式调用
 */

export var common = [].concat(common_authority, common_anonymous);
/**
 * 微信需要使用的JS接口列表-invoke方式调用
 */

export var invoke = [].concat(invoke_authority, invoke_anonymous);
/**
 * 微信需要使用的JS接口列表-所有接口
 */

export var all = [].concat(common, invoke);
/**
 * 微信需要使用的JS接口列表-需要鉴权的
 */

export var authority = [].concat(common_authority, invoke_authority);
export var jsApiList = {
  common_authority: common_authority,
  common_anonymous: common_anonymous,
  invoke_authority: invoke_authority,
  invoke_anonymous: invoke_anonymous,
  common: common,
  invoke: invoke,
  all: all,
  authority: authority
};
export default jsApiList;